module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Master Manage')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [(_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-lg btn-menu",
    attrs: {
      "to": "/user_types"
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('User Type')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-violet btn-lg btn-menu",
    attrs: {
      "to": "/domains"
    }
  }, [_c('i', {
    staticClass: "fa fa-at"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Domain Type')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-teal btn-lg btn-menu",
    attrs: {
      "to": "/turnover_types"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Turnover Type')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-blue btn-lg btn-menu",
    attrs: {
      "to": "/joins"
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Join Type')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-danger btn-lg btn-menu",
    attrs: {
      "to": "/reject_reasons"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Reject Reason')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": "/guidelines"
    }
  }, [_c('i', {
    staticClass: "fa fa-road"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Guideline')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-llg btn-menu",
    attrs: {
      "to": "/question"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Questions')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-llg btn-menu",
    attrs: {
      "to": "/normal_question"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Normal Questions')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-llg btn-menu",
    attrs: {
      "to": "/ability_question"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Ability Questions')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-llg btn-menu",
    attrs: {
      "to": "/master/service_questions"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Service Questions')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isMachineOrderAdmin) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-llg btn-menu",
    attrs: {
      "to": "/master/machine_order_shop"
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Machine Order Shop')))])])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d565eb8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master.pug
// module id = 771
// module chunks = 1